import { CookieBanner } from './cookie-banner';
import { CookieSettingsDrawer } from './cookie-settings-drawer';

export function CookieDialog() {
  return (
    <>
      <CookieBanner />
      <CookieSettingsDrawer />
    </>
  );
}

export { CookieBanner } from './cookie-banner';
export { CookieSettingsDrawer } from './cookie-settings-drawer';
